import { gql } from 'apollo-boost';

export const USER_DETAILS_QUERY = gql`
  query person {
    person {
      id
      username
      groups {
        id
        name
        type
        attributes {
          id
          dataFormat
          dataType
          name
          value
        }
      }
    }
  }
`;
